import { TreeSelect } from 'antd';
import styled from 'styled-components';

export const MyTreeSelect = styled(TreeSelect)`
    font-size: ${(props: any) =>
        props?.fontScale !== undefined
            ? `${16 + props?.fontScale * 1.5}px`
            : '16px'} !important;
`;
